$(document).ready(function () {
  function getNumpadForInput(input) {
    return $('.numpad').filter(function () {
      return $($(this).data('target')).is(input);
    });
  }

  function sanitizeNumpadValue(value, decimalSeparator, maxDecimals) {
    let sanitized = '';
    let hasSeparator = false;
    let decimals = 0;

    for (const char of value.replace(/[.,]/g, decimalSeparator)) {
      if (char >= '0' && char <= '9') {
        if (hasSeparator) {
          if (decimals >= maxDecimals) {
            continue;
          }
          decimals++;
        }
        sanitized += char;
      } else if (
        char === decimalSeparator &&
        !hasSeparator &&
        maxDecimals > 0
      ) {
        hasSeparator = true;
        sanitized += (sanitized === '' ? '0' : '') + char;
      }
    }

    return sanitized;
  }

  function replaceNumpadSelection(input, text, deleteBefore = false) {
    const element = input[0];
    const value = input.val();
    let start = element.selectionStart ?? value.length;
    const end = element.selectionEnd ?? value.length;

    if (deleteBefore && start === end) {
      start = Math.max(0, start - 1);
    }

    input.val(value.slice(0, start) + text + value.slice(end));
    element.setSelectionRange(start + text.length, start + text.length);
    input.trigger('input');
  }

  // Keep focus on the input so the physical keyboard keeps working while the keys are tapped
  $(document).on('mousedown', '.numpad__key', function (e) {
    e.preventDefault();
  });

  $(document).on('click', '.numpad__key', function () {
    const numpad = $(this).closest('.numpad');
    const input = $(numpad.data('target'));
    const key = String($(this).data('key'));

    switch (key) {
      case 'backspace':
        replaceNumpadSelection(input, '', true);
        break;
      case 'keyboard':
        $(this).toggleClass('active');
        input.attr(
          'inputmode',
          $(this).hasClass('active') ? 'decimal' : 'none'
        );
        input.trigger('blur').trigger('focus');
        break;
      case 'enter':
        $(numpad.data('submit')).trigger('click');
        break;
      case 'decimal':
        replaceNumpadSelection(input, numpad.data('decimal-separator'));
        break;
      default:
        replaceNumpadSelection(input, key);
    }
  });

  $(document).on('input', '.numpad-input', function () {
    const numpad = getNumpadForInput(this);
    if (!numpad.length) {
      return;
    }

    const value = $(this).val();
    const sanitized = sanitizeNumpadValue(
      value,
      numpad.data('decimal-separator'),
      parseInt(numpad.data('max-decimals'))
    );

    if (sanitized !== value) {
      $(this).val(sanitized);
    }
  });

  $(document).on('keydown', '.numpad-input', function (e) {
    if (e.key === 'Enter' && !e.originalEvent.repeat) {
      e.preventDefault();
      $(getNumpadForInput(this).data('submit')).trigger('click');
    }
  });
});
